import Strings from '@kfc-global/react-shared/constants/Strings';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const getAmenities = [
  {
    key: Strings.roundTheClock,
    image: IMAGE_PATH.RoundTheClockDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.ROUND_THE_CLOCK),
  },
  {
    key: Strings.birthday,
    image: IMAGE_PATH.BirthdayDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.BIRTHDAY),
  },
  {
    key: Strings.breakfast,
    image: IMAGE_PATH.BreakfastDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.BREAKFAST),
  },
  {
    key: Strings.contactless,
    image: IMAGE_PATH.ContactlessDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.CONTACTLESS),
  },
  {
    key: Strings.driveThru,
    image: IMAGE_PATH.DrivethruDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.DRIVETHRU),
  },
  {
    key: Strings.driveThruOnly,
    image: IMAGE_PATH.DrivethruDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.DRIVETHRU),
  },
  {
    key: Strings.foodCourt,
    image: IMAGE_PATH.FoodCourtDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.FOODCOURT),
  },
  {
    key: Strings.wifi,
    image: IMAGE_PATH.WifiDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.FREE_WIFI),
  },
  {
    key: Strings.wifiOnly,
    image: IMAGE_PATH.WifiDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.WIFI),
  },
  {
    key: Strings.kiosks,
    image: IMAGE_PATH.KiosksDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.KIOSKS),
  },
  {
    key: Strings.parking,
    image: IMAGE_PATH.ParkingDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.PARKING),
  },
  {
    key: Strings.playground,
    image: IMAGE_PATH.PlaygroundDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.PLAYGROUND),
  },
  {
    key: Strings.refill,
    image: IMAGE_PATH.RefillDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.REFILL),
  },
  {
    key: Strings.terraces,
    image: IMAGE_PATH.TerracesDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.TERRACES),
  },
  {
    key: Strings.phc,
    image: IMAGE_PATH.AccessibilityDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.ACCESSIBILTY),
  },
  {
    key: Strings.accessibility,
    image: IMAGE_PATH.AccessibilityDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.ACCESSIBILTY),
  },
  {
    key: Strings.restroom,
    image: IMAGE_PATH.RestRoomDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.RESTROOM),
  },
  {
    key: Strings.cateringType,
    image: IMAGE_PATH.BirthdayDark,
    label: translateWithI18Next(TRANSLATE_MAPPING_KEY.CATERING_TEXT),
  },
];
export const getFacilities = (storeInfo, rdpPage) => {
  // eslint-disable-next-line array-callback-return
  return getAmenities.filter(amenity => {
    if (storeInfo?.amenities?.length) {
      return storeInfo?.amenities?.indexOf(amenity?.key) >= 0;
    }
  });
};
